import { keepPreviousData } from '@tanstack/react-query';

import { ExperimentsPolicy } from '@playq/octopus2-analytics';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

const policyExperimentsQueryKeys: unknown[] = ['corp', 'policies', 'experiments', 'query'];

export const usePolicyExperimentsQuery = (
  options?: IUseQueryOptionsExtended<ExperimentsPolicy | undefined, GenericFailure | Error>
) => {
  return useEitherQuery(policyExperimentsQueryKeys, () => services2.experimentsAdminService.retrievePolicy(), {
    placeholderData: keepPreviousData,
    ...options,
  });
};
